import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';

@Injectable({ providedIn: 'root' })
export class ServiceAccessService extends ApiService {
	getServicesForAccount(accountNumber: string) {
		return this.get(API.getServicesForAccount(accountNumber));
	}
}
